import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
const IconSleekSilhouetteChair = t0 => {
  const {
    color: t1,
    width: t2,
    height: t3,
    className: t4
  } = t0;
  t1 === undefined ? colorGray : t1;
  t2 === undefined ? "48" : t2;
  t3 === undefined ? "48" : t3;
  t4 === undefined ? "" : t4;
};
IconSleekSilhouetteChair.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string
};
export default IconSleekSilhouetteChair;